import { HttpClient } from '@adapters/HttpClient';

export interface ShopOption {
  id: number;
  name: string;
}

export class ShopsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getAll(): Promise<ShopOption[]> {
    const raw = await this.httpClient.get<any>('/shops');
    const list = Array.isArray(raw) ? raw : (raw.data ?? []);
    return list.map((shop: any) => ({
      id: shop.id,
      name: shop.name,
    }));
  }
}

